<template>
   <header class="main-header">
      <!-- <div class="back-btn"><img :src='require("../../assets/images/back.svg")' alt=""></div>
      <div class="filter"><img :src='require("../../assets/images/filters.svg")' alt=""></div> -->
      <h1 class="logo">
        <img :src='require("../../assets/images/logo.svg")' alt="logo">
        <span>{{$t('Baatein91')}}</span>
      </h1>
    </header>
</template>
<script>
export default {
  name: "Header",
  components: {},
  props: {
    userDetail: Object
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
